import * as React from "react";

const Version: React.FC = () => {
  return <>1.34.3 </>;
};

export default Version;
